var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTareas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2419_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.42857 1.875V3.75H3.21429C1.43973 3.75 0 5.00977 0 6.5625V9.375H30V6.5625C30 5.00977 28.5603 3.75 26.7857 3.75H23.5714V1.875C23.5714 0.837891 22.6138 0 21.4286 0C20.2433 0 19.2857 0.837891 19.2857 1.875V3.75H10.7143V1.875C10.7143 0.837891 9.7567 0 8.57143 0C7.38616 0 6.42857 0.837891 6.42857 1.875ZM30 11.25H0V27.1875C0 28.7402 1.43973 30 3.21429 30H26.7857C28.5603 30 30 28.7402 30 27.1875V11.25Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2419_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTareas);
export default __webpack_public_path__ + "static/media/Tareas.e7c666db7785b878f2beb677ec319fbc.svg";
export { ForwardRef as ReactComponent };